import { render } from "./Discover.vue?vue&type=template&id=70a804da"
import script from "./Discover.vue?vue&type=script&lang=js"
export * from "./Discover.vue?vue&type=script&lang=js"

import "./Discover.vue?vue&type=style&index=0&id=70a804da&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/lostsailor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__